import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import { fetchPassage } from "../../../api/BibleApi";
import { chapterPath } from "../../../utils/paths";
import PopupContainer from "./PopoverContainer";

class VerseActionPopover extends React.Component {
  static propTypes = {
    render: PropTypes.func.isRequired,
    bibleId: PropTypes.string.isRequired,
    selectedVerseOrgIds: PropTypes.arrayOf(PropTypes.string).isRequired
  };

  state = { url: null, message: null };

  componentDidMount = () => this.makePassageRequest();

  componentDidUpdate(prevProps) {
    if (prevProps.selectedVerseOrgIds !== this.props.selectedVerseOrgIds) {
      this.makePassageRequest();
    }
  }

  makePassageRequest = () => {
    const { bibleId, selectedVerseOrgIds } = this.props;
    const passageId =
      selectedVerseOrgIds.length > 1
        ? `${selectedVerseOrgIds[0]}-${
            selectedVerseOrgIds[selectedVerseOrgIds.length - 1]
          }`
        : selectedVerseOrgIds[0];

    let fullUrl = "";
    if (window) {
      const hostname = window.location.hostname.replace(
        "lvh.me",
        "global.bible"
      );
      const verseElemArray =
        selectedVerseOrgIds.length > 0 ? selectedVerseOrgIds[0].split(".") : "";
      const chapterId =
        selectedVerseOrgIds.length > 0
          ? [verseElemArray[0], verseElemArray[1]].join(".")
          : "";
      fullUrl = `https://${hostname}${chapterPath({
        bibleId,
        chapterId,
        passageId
      })}`;
    }

    return fetchPassage({ bibleId, passageId }).then(message => {
      this.setState({ url: fullUrl, message });
    });
  };

  render() {
    if (!this.state.message) return null;
    return (
      <PopupContainer onClick={e => e.stopPropagation()}>
        {this.props.render(this.state)}
      </PopupContainer>
    );
  }
}

export default withRouter(VerseActionPopover);
